<template>
  <v-expansion-panel :value="hasFamilyPlan() ? 0 : null">
    <manage-plus-one-clients :show.sync="showManageClients" :fetchData="fetchData" :planSize.sync="planSize"/>
    <v-expansion-panel-content>
      <template v-slot:header>
        <div class="plan-title itoviPrimary--text">{{ hasFamilyPlan() ? planDetails.name : 'Family'}}</div>
      </template>
      <v-divider />
      <v-card class="pl-4 pr-4 pt-1 pb-2">
        <div class="mb-2">{{ planDetails.description }}</div>
        <v-layout align-center row wrap>
          <span class="txt-semi-bold">Monthly:&nbsp;</span>
          <span class="txt-semi-bold">${{ getRecurringPrice() }}</span>
          <span class="txt-semi-bold txt-subscript">&nbsp;/ mo</span>
        </v-layout>

        <!--      what's included section          -->
        <div class="mt-2 mb-2">
          <ul>
            <li>Free Plus One Client</li>
          </ul>
        </div>
        <template v-if="hasFamilyPlan()">
          <div class="mt-2 mb-2">
            <b>Plus One:</b> {{activePlusOneClients.length ? activePlusOneClients[0].name : 'Unassigned'}}
            <v-icon v-if="plusOneClients.clients.length && planSize < 1" small color="primary" @click="changePlusOneInfo = !changePlusOneInfo">
              info_outline
            </v-icon>
          </div>
          <div class="contact-support" v-if="changePlusOneInfo" @click="$store.commit('setShowCustomerSupportDialog', true)">
            To change your plus one <span class="itoviPrimary--text">Contact Customer Support</span>
          </div>
        </template>
        <v-divider />

<!--        add additional people section-->
        <v-layout column class="mt-3">
          <v-flex class="plan-title itoviPrimary--text">
            <v-layout row justify-space-between align-center>
              <div>Additional People</div>
              <div>
                <v-btn small flat color="accent"
                   v-if="(plusOneClients.clients.length + plusOneClients.open_slots) > 1"
                   @click="showManageClients = true" class="txt-bold mt-0 mt-2">Manage People
                </v-btn>
              </div>
            </v-layout>
          </v-flex>
          <v-flex class="font-weight-bold" v-if="hasFamilyPlan()">Monthly Add Ons: ${{ formatPrice(plusOnePrice * planSize) }}</v-flex>
          <v-flex v-if="hasFamilyPlan()">People on Plan: {{ planSize }}</v-flex>
          <v-flex>
            <ul>
              <li>Add people to your plan for ${{ plusOnePrice }}/month</li>
              <li>Daily Scan for each person</li>
            </ul>
          </v-flex>
          <v-flex>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3 mb-1" v-if="hasFamilyPlan() && planDetails.status === 'paused'">
          <img src="../../../assets/paused_icon.svg" class="mr-1 mb-1" height="22" width="22" alt="paused"/>
          <v-flex><strong>Your account is paused due to failed payments</strong></v-flex>
        </v-layout>

        <template v-else>
          <v-layout row justify-center align-center class="mt-4">
            <div class="pr-3"><b>${{ plusOnePrice }} per Person</b></div>
            <div>
              <v-select
                  style="width: 150px"
                  v-model="selectedPlan"
                  :items="qtyOptions"
                  label="Qty:"
              />
            </div>
          </v-layout>
          <v-layout justify-center wrap class="mt-4 mb-4">
            <button v-if="!isAppView" @click="upgradePlan()" :disabled="!selectedPlan" :class="selectedPlan ? 'button-blue' : 'button-gray-disabled'">
              {{ hasFamilyPlan() ? 'Add to Plan' : 'Change Plan to Family' }}
            </button>
            <div class="text-xs-center" v-else >Log in to your iTOVi dashboard from a web browser to change your plan to <b>{{ planDetails.name }}</b></div>
          </v-layout>
        </template>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import store from "@/store";
import api from "@/services/api_endpoints";
import subscribeToStore from "@/mixins/subscribeToStore";
import { formatPrice } from "../../../helpers/priceHelper";
import ManagePlusOneClients from "@/components/dashboard/yourPlanCard/ManagePlusOneClients";

  export default {
    data: ()=> ({
      planDetails: store.state.planDetails,
      nextPayment: store.state.nextPayment,
      showConfirmDialog: store.state.showConfirmDialog,
      isAppView: store.state.isAppView,
      user: store.state.user,
      ccInfo: store.state.ccInfo,
      plusOneClients: store.state.plusOneClients,
      qtyOptions: [],
      selectedPlan: null,
      planSize: 0,
      plusOnePrice: 2.99,
      familyRegex: /FAMILY\+[0-9]+/,
      showManageClients: false,
      changePlusOneInfo: false,
      activePlusOneClients: []
    }),
    components: {
      ManagePlusOneClients
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['user', 'planDetails', 'ccInfo', 'nextPayment', 'showConfirmDialog', 'isAppView', 'plusOneClients']);
      this.fetchData();
    },
    watch: {
      planDetails: function () {
        this.setQtyOptions();
      },
      plusOneClients: function () {
        this.activePlusOneClients = this.plusOneClients.clients.filter(client => !client.expires_on);
      }
    },
    methods: {
      formatPrice: formatPrice,
      hasFamilyPlan(){
       return !!this.planDetails.product_code.match(this.familyRegex);
      },
      async fetchData() {
        await api.getPlusOneClients();
        this.setQtyOptions();
      },
      setQtyOptions() {
        if (!this.planDetails.family_plans.length) return;
        const planCount = this.hasFamilyPlan() ? this.planDetails.product_code.split('+')[1] : 0;
        const options = this.planDetails.family_plans.filter((plan) => {
          let count = plan.product_code.split('+')[1];
          return (count > planCount);
        });

        //exclude free plus one
        this.planSize = planCount - 1 > 0 ? planCount - 1 : 0;
        this.qtyOptions = options.map((plan, key) => {return {text: this.hasFamilyPlan() ? key + 1 : key,  value: plan.product_code }});
      },
      showConfirmPlanChangeDialog(plan) {
        // console.log(plan)
        // the the payment info so we can tell the user what card they are paying with
        this.ccInfo = store.state.ccInfo
        store.commit('setPlanToConfirm', plan);
        store.commit('setShowConfirmDialog', true);
      },
      upgradePlan() {
        const plan = this.planDetails.family_plans.filter(plan => plan.product_code === this.selectedPlan)[0];
        if (!plan) return;

        this.showConfirmPlanChangeDialog(plan);
      },
      getRecurringPrice() {
        if (this.planDetails.product_code === 'FAMILY+1') {
          return this.planDetails.monthly;
        }
        const familyPlusOnePlan = this.planDetails.family_plans.filter((plan) => plan.product_code.split('+')[1] === '1')[0];
        return familyPlusOnePlan ? familyPlusOnePlan.monthly : null;
      },
  }
}
</script>

<style type="css" scoped>
  .contact-support {
    width: fit-content;
    padding: 6px 12px;
    margin-bottom: 12px;
    font-size: 12px;
    background: #F2F4F5;
    box-shadow: 0 1px 5px #00000033;
  }
  .contact-support:hover {
    cursor: pointer;
  }
</style>
